var map = {
	"./Ethereum.png": 940,
	"./avatar.png": 941,
	"./base.png": 942,
	"./bos.png": 943,
	"./coffe.png": 944,
	"./eos.png": 839,
	"./favorites.png": 945,
	"./health-check.png": 946,
	"./jungle.png": 947,
	"./local.png": 948,
	"./matic.png": 840,
	"./pbtc.png": 949,
	"./proton.png": 567,
	"./resize.png": 841,
	"./select_network.png": 842,
	"./solana.png": 950,
	"./space.png": 951,
	"./space2.png": 952,
	"./swap.png": 953,
	"./telos.png": 954,
	"./ultra.png": 568,
	"./usdc.png": 955,
	"./usdt.png": 956,
	"./ux.png": 957,
	"./wax.png": 834,
	"./waxtest.png": 958,
	"./weth.png": 959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;